import React, { MouseEventHandler } from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';

type ActionButtonProps =
  | {
      isLink: true;
      label: string;
      url: string;
    }
  | {
      isLink: false;
      label: string;
      iconName: string;
      onClick: MouseEventHandler;
    };

const DrawerActionButton: React.FC<ActionButtonProps> = (props) => {
  const { isLink, label } = props;
  const iconName = isLink ? 'link' : props.iconName;
  const buttonProps = isLink ? { href: props.url, target: '_blank' } : { onClick: props.onClick };

  return (
    <ListItem disablePadding sx={{ width: 'auto' }}>
      <ListItemButton {...buttonProps}>
        <ListItemIcon sx={{ minWidth: 'auto', mr: 2 }}>
          <PolarisIcon icon={iconName} height={18} style={{ opacity: 0.7 }} />
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </ListItemButton>
    </ListItem>
  );
};

export default DrawerActionButton;
